// extracted by mini-css-extract-plugin
module.exports = {"button":"styles_button__3mQvN","list":"styles_list__3FGqx"};